export default {"src":"/_next/static/media/icon-duplication-warning.fe5832f0.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};